import styled from 'styled-components';

export const Wrapper = styled.div<{ selected: boolean }>`
  width: 100%;
  height: 112px;

  padding: 12px;

  background: #ffffff;

  border: 1px solid
    ${props => (props.selected ? props.theme.colors.primary.main : '#D9D9D9')};
  border-radius: 12px;

  gap: 6px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  cursor: pointer;

  overflow: hidden;

  position: relative;

  &:hover {
    border: 1px solid ${props => props.theme.colors.primary.main};
  }

  .tick {
    width: 24px;
    height: 24px;
    background: ${props => props.theme.colors.primary.main};

    position: absolute;
    top: 0px;
    right: 0px;

    border-bottom-left-radius: 18px;
    border-bottom-right-radius: 0px;

    display: ${props => (props.selected ? 'flex' : 'none')};

    svg {
      position: absolute;
      top: 6px;
      left: 8px;
    }
  }
`;

export const IconWrapper = styled.div`
  width: 42px;
  height: 42px;
  background: ${props => props.theme.colors.primary.main};

  border-radius: 50%;

  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 24px;
    height: 24px;

    path,
    rect {
      fill: #ffffff;
    }
  }
`;
